import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import * as colors from '@constants/colors';
import { Button, TextField } from '@mui';
import UnstyledHeading from '@components/shared/unstyled-heading';

import '../layouts/not-authenticated/not-authenticated.scss';

const PASSWORD_RESET_HEADER_ID = 'auth-password-reset';

const ResetRequest = ({
  requestedResetStatus, emailErrorText, formChange, formSubmit
}) => {
  const dispatch = useDispatch();

  const gotoLogin = useCallback(() => dispatch(push('/login/')), [dispatch]);

  return (
    <main data-testid="reset-request" aria-labelledby={PASSWORD_RESET_HEADER_ID}>
      <UnstyledHeading rank={2} id={PASSWORD_RESET_HEADER_ID} styleName="auth-heading"> Reset Password </UnstyledHeading>
      {(requestedResetStatus !== 201)
        ?
        <div>
          <div styleName="auth-section">
            <div>
              Please enter your email address. We will send you an email that will contain a link to a page where you can reset your password.
            </div>
          </div>
          <form onSubmit={formSubmit}>
            <div styleName="not-authenticated-form-text-field">
              <TextField
                fullWidth
                id="email"
                name="email"
                label="Email address"
                autoComplete="email"
                onChange={formChange}
                error={emailErrorText?.length > 0}
                helperText={emailErrorText}
              />
            </div>
            <div>
              <Button
                color="primary"
                fullWidth
                type="submit"
                variant="contained"
              >
                SEND PASSWORD RESET
              </Button>
            </div>
          </form>
        </div>
        :
        <div styleName="auth-section">
          <div role="status" aria-live="polite">
            If the email is correct, we will send a password reset to your email address.
          </div>
          <Button
            onClick={gotoLogin}
            style={{
              color: colors.dotmapsDoneGreen,
              border: `.1em solid ${colors.dotmapsDoneGreen}`,
              borderRadius: '.2em',
              lineHeight: '2em',
              width: '12em'
            }}
          >
            Done
          </Button>
        </div>
      }
    </main>
  );
};

ResetRequest.propTypes = {
  emailErrorText: PropTypes.string,
  formChange: PropTypes.func,
  formSubmit: PropTypes.func,
  requestedResetStatus: PropTypes.number
};

export default ResetRequest;
